import { render, staticRenderFns } from "./SuppliersMerchandise.vue?vue&type=template&id=31010964&lang=pug"
import script from "./SuppliersMerchandise.vue?vue&type=script&lang=js"
export * from "./SuppliersMerchandise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports